import { useFloating as K, offset as T, shift as k, flip as A, autoUpdate as S, limitShift as v } from "@floating-ui/react";
import { useEffect as C, useCallback as d, useRef as H } from "react";
import { getNextItemFromSearch as L } from "../../../utils/array/index.js";
import { isHTMLElement as w, normalizeEventKey as O } from "../../../utils/dom/index.js";
import { callAllHandlers as U } from "../../../utils/function/index.js";
import { useMenuContext as z } from "../useMenuContext.js";
import { useMenuDescendantsContext as B } from "../useMenuDescendantsContext.js";
import { useShortcut as P } from "../../../utils/hooks/useShortcut.js";
import { useMergeRefs as W } from "../../../utils/hooks/useMergeRefs.js";
const j = (t) => w(t) && t.getAttribute("role") === "menu", M = (t) => (
  // this will catch `menuitem`, `menuitemradio`, `menuitemcheckbox`
  w(t) && !!t.getAttribute("role")?.startsWith("menuitem")
), q = ({
  descendants: t,
  onClose: i,
  focusedIndex: l,
  setFocusedIndex: n,
  createTypeaheadHandler: m
}) => d(
  (r) => {
    const u = O(r), s = {
      Tab: () => {
        i?.();
      },
      Escape: () => {
        i?.();
      },
      ArrowDown: () => {
        const o = t.nextEnabled(l), e = t.firstEnabled();
        o ? n(o.index) : e && n(e.index);
      },
      ArrowUp: () => {
        const o = t.prevEnabled(l), e = t.lastEnabled();
        o ? n(o.index) : e && n(e.index);
      }
    }[u];
    if (s) {
      u !== "Tab" && r.preventDefault(), s(r);
      return;
    }
    const p = m((o) => {
      const e = L(
        t.values(),
        o,
        (a) => a?.node?.textContent ?? "",
        t.item(l)
      );
      if (e) {
        const a = t.indexOf(e.node);
        n(a);
      }
    });
    (M(r.target) || j(r.target)) && p(r);
  },
  [t, l, m, i, n]
), F = ({ placement: t, ...i } = { placement: "bottom-start" }, l = null) => {
  const n = z();
  if (!n)
    throw new Error(
      "useMenuContext: context is undefined. Seems you forgot to wrap component within <Menu>"
    );
  const { focusedIndex: m, setFocusedIndex: r, menuRef: u, setMenuRef: y, buttonRef: s, opened: p, onClose: o, menuId: e } = n, a = B(), {
    x: b,
    y: g,
    refs: c,
    strategy: x
  } = K({
    whileElementsMounted: S,
    // This will auto update the position of dropdown as long as the dropdown is rendered. It is expensive operation, so it should only be performed when necessary.
    placement: t,
    middleware: [
      T(4),
      // Makes sure that there is a space between button and dropdown.
      k({ limiter: v() }),
      // If there is not enough space this will move dropdown "alignment", so it remains visible on the screen
      A({
        fallbackStrategy: "initialPlacement"
      })
      // In case there is not enough space it will flip the dropdown to the opposite "side", using the specified "placement" if neither side fits.
    ]
  });
  C(() => {
    c.setReference(s);
  }, [c, s]);
  const h = P({
    preventDefault: (f) => f.key !== " " && M(f.target)
  }), E = q({
    descendants: a,
    onClose: o,
    focusedIndex: m,
    setFocusedIndex: r,
    createTypeaheadHandler: h
  }), D = H(!1);
  p && (D.current = !0);
  const R = W({ current: u }, l);
  return {
    ...i,
    ref: (f) => {
      R(f), c.setFloating(f), y(f);
    },
    tabIndex: 0,
    role: "menu",
    id: e,
    "aria-orientation": "vertical",
    onKeyDown: U(i.onKeyDown, E),
    style: {
      position: x,
      top: g ?? 0,
      left: b ?? 0,
      /*
       * Dropdown node needs to be rendered, before Floating UI can calculate the dimensions of the node
       * and therefor the position of the node. However, as this calculation is happening, for a second
       * the Dropdown will be placed in [0, 0] coordinates, which looks glitchy.
       * To solve that problem we can set "visibility" to "hidden" as the calculation is happening and when it
       * is done "visibility" is set to "visible".
       */
      visibility: b === null || g === null ? "hidden" : "visible"
    }
  };
};
export {
  F as useMenuList
};
//# sourceMappingURL=useMenuList.js.map
